import React, { useState, useEffect, useRef, useCallback } from 'react';
import './NewsTerminal.css';

import posterCompressed from './assets/images/NEUTRALS_TEASER_FINAL_COMPRESSED.webp'
import poster from './assets/downloads/NEUTRALS_TEASER_FINAL.jpg';
import wallpapersZip from './assets/downloads/NEUTRALS_WALLPAPERS.zip';
import christmasAnnouncementCompressed from './assets/images/Christmas_Announcement_2_COMPRESSED.webp';
import celebrationFlyerCompressed from './assets/images/Neutrals_Celebration_Flyer_Compressed.webp';
import celebrationFlyer from './assets/downloads/Neutrals_Celebration_Flyer.jpg';
import { TICKETS_URL, VENUE_MAP_URL } from './eventLinks';

// Full cast & crew, reused both at the tail of the launch dispatch (its
// original home) and by the dedicated `credits` file the command shell can
// `cat` directly — one JSX literal, so the two views can never drift apart.
const CreditsBlock = () => (
  <>
    Web Director/Head Developer - Justin Morrow (<a href="mailto:justin.morrow81+2jakes@gmail.com">Contact</a>)
    <br />
    Graphic Designer/Character Models - Nick Wracan
    <br />
    Viewfinder Photos - Andrew Colohan, Jake Fidler, J.R. O'Brien
    <br />
    Vol. 1 Music - Cheap Beer, Connor McBain, J.R. O'Brien, SlasherBoy, The
    Sleepy Boys, The Stepmothers, Wavpool, and Willy FoTang
    <br />
    <br />
    Neutrals (2025) -{' '}
    <a
      href="https://www.imdb.com/title/tt30761083/?ref_=nv_sr_srsg_2_tt_8_nm_0_in_0_q_Neutrals"
      target="_blank"
      rel="noopener noreferrer"
    >
      Bookmark the film now on IMDb!
    </a>
    <br />
    <br />
    - CREW -
    <br />
    <br />
    Written/Produced/Directed by Jacob Horne
    <br />
    Produced by J.R. O'Brien
    <br />
    Line Producers - Brennan Bauer, Delores Flynn
    <br />
    Cinematography - Chene Coffin
    <br />
    Lighting  - Ben Murphy, Andrew Colohan
    <br />
    Camera Assistants - Michael Pochotko, Jay Crone, Ben Polehna, Will
    Dowen
    <br />
    Sound - Charlie Ours, Nina B.E.
    <br />
    Art Director - Shane Hillier
    <br />
    Costuming - Oliva Carlson
    <br />
    VFX - Matt Jarjosa
    <br />
    Original Music - The Stepmothers
    <br />
    Featuring Music from Normal, Juan Cordero, FishFly, SlasherBoy
    <br />
    <br />
    - CAST -
    <br />
    <br />
    Daniel Brabow as Chris
    <br />
    Josh Brockett as Dan
    <br />
    Steven Weed as Wes
    <br />
    Calhoun Koenig as Jade
    <br />
    Dale Dobson as Sheriff Stevenson
    <br />
    Jimmy Doom as Henry
    <br />
    Gerard Wilkinson as Jay
    <br />
    Whitney Wagner as Guy
    <br />
    Sandro Rodriguez as Mick
    <br />
    Steve Larson as Officer Hyde
    <br />
    Tyler Bowen as Chuck
    <br />
    Connor McBain as Sparky
    <br />
    Matt Jarjosa as Bradley
  </>
);

// The dispatches, newest first — same real copy the old single-scroll
// feed used, just reshaped into addressable "files" so the sidebar, the
// `cat`/`ls` commands and the detail pane can all point at the same data.
// `slug` is the filename the command shell resolves against; `teaser` is
// only ever shown as a short nav hint in the sidebar, never in the post
// itself.
const DISPATCHES = [
  {
    slug: 'neutrals_x_normal.log',
    header: '[SYSTEM NOTICE — NEUTRALS X NORMAL] [10/1/2026]',
    teaser: 'Nov 28 · Planet Ant Theatre · Tickets on sale',
    byline: null,
    body: (
      <>
        <strong>THE TWO JAKES PRESENT: NEUTRALS X NORMAL</strong>
        <br /><br />
        SEE THE BAND. EXPERIENCE THE FILM.
        <br /><br />
        Join Horne and O’Brien, and NORMAL in-person on Saturday, November 28th at the Planet Ant Theatre for this special one-of-a-kind event.{' '}
        <a href={TICKETS_URL} target="_blank" rel="noopener noreferrer">
          Tickets on sale now
        </a>.
        <br /><br />
        <a href={VENUE_MAP_URL} target="_blank" rel="noopener noreferrer">
          2320 Caniff St<br />
          Hamtramck, MI 48212<br />
          United States
        </a>
        <br /><br />
        <strong>Location</strong>: Planet Ant Theatre
        <br /><br />
        <strong>Doors open</strong>: 2:00 PM, outside theatre entrance
        <br /><br />
        Official commemorative materials will be available on-site, including NEUTRALS T-shirts, mini posters of artwork by Steven Weed (Wes), and newly unearthed (very limited*) physical copies of the ultra-cool pitch package zine designed by O’Brien during the pre-production phase of NEUTRALS. These were only given to investors and will never be re-printed.
      </>
    ),
    log: [],
  },
  {
    slug: 'system_update_2.0.log',
    header: '[SYSTEM UPDATE 2.0 - 2JAKES.TV] [9/27/2026]',
    teaser: "2Jakes.TV 2.0: new score + new tunes",
    byline: null,
    body: (
      <>
        Welcome home, soldier. Let's catch up.
        <br /><br />
        Fall is here, and so is the biggest update to the 2Jakes.TV experience since the platform's launch. Every application has been rebuilt from the ground up, each with its own unique little personality and welcoming aesthetic designed to make interacting with the system an absolute joy.
        <br /><br />
        We're happy to be exclusively releasing the official score to <em>NEUTRALS</em> by <strong>The Stepmothers</strong> right here on 2Jakes.TV. Find it waiting for you in the dedicated playlist within the music application (J2nZ).
        <br /><br />
        J2nZ (pronounced <em>jTunes</em>*) now allows you to cycle through a selection of visualizers while listening to your favorite music. Just tap the window and see what happens.
        <br /><br />
        OVER 60 MINUTES OF NEW MUSIC FROM:
        <br /><br />
        <strong>Hi There!</strong><br />
        <strong>Marisa Nahas</strong><br />
        <strong>Mars Spierling</strong><br />
        <strong>MINDJAKKED</strong><br />
        <strong>The Holdovers</strong><br />
        <strong>Studio Lounge</strong><br />
        <strong>WhoShotTokyo</strong><br />
        <strong>333bino</strong>
        <br /><br />
        And lastly... the rumors are true. The most righteous return of <strong>The Sleepy Boys</strong>, with three NEW singles <em>The Soft Song</em>, <em>I Can't Say</em>, and <em>Turn</em> available NOW before they launch on any other service...
        <br /><br />
        The following short films are also now available <strong>AD FREE</strong> in the DVD Player:
        <br /><br />
        <strong>BOILING POINT</strong> — directed by Nathan Gallagher<br />
        <strong>HIGH-JINKS</strong> — directed by Sam Carroll<br />
        <strong>Y Dontcha Go on n Ask Urself!</strong> — directed by Matt Baum
        <br /><br />
        Thank you to all of the artists who contributed their work and helped make 2Jakes.TV what it is today: the &ldquo;Resident Evil Save Room&rdquo; of the Detroit underground.
      </>
    ),
    log: [
      { cmd: 'deploy("2jakes_os_2.0")', out: 'Status: online' },
      { cmd: 'mount("j2nz_visualizers")', out: 'Modules: loaded' },
    ],
  },
  {
    slug: 'cinematic_debrief.log',
    header: '[SYSTEM NOTICE — CINEMATIC DEBRIEF]',
    teaser: 'Recap: the Celebration Screening',
    byline: "— O'Brien / Horne",
    body: (
      <>
        We'd like to thank you all for your unwavering support at the official NEUTRALS Celebration Screening, held on January 25, 2026, at the MJR Cinema in Troy, Michigan. The evening also marked the six-year anniversary of the original short film premiere at the Motion Picture Institute in 2020.
        <br /><br />
        It was a night charged with unprecedented energy, bringing together some of the most talented artists in the region under one roof. To commemorate the occasion, we're pleased to offer high-quality downloads of every photograph from the red carpet and Q&A session, beautifully captured by Jay Richie (<a href="https://www.instagram.com/RawRefinedVisuals/" target="_blank" rel="noopener noreferrer">@RawRefinedVisuals</a> on Instagram).
        <br /><br />
        View and download the photos in the <strong>View Master</strong> app (tap the white wheel icon at the bottom of this window), or alternatively <a href="https://drive.google.com/drive/folders/1YrzqzXmdMaF30k8XJ7w_wqX-5omKsq1c?usp=drive_link" target="_blank" rel="noopener noreferrer">see the collection here</a>.
        <br /><br />
        While there are no public screenings scheduled at this time, we leave you with the promise that NEUTRALS will soon be making its way to a film festival near you&mdash;and, with any luck, will be physically printed for you to own and experience at home.
        <br /><br />
        We salute you, Soldiers of Cinema&mdash;those who continue to fight, and those we've lost while arriving at this moment. We love you all.
      </>
    ),
    log: [
      { cmd: 'query("event_archive")', out: 'Status: archived' },
      { cmd: 'signal("broadcast")', out: 'Signal: excellent' },
      { cmd: 'status("system")', out: 'System: stable' },
    ],
  },
  {
    slug: 'screening_jan25.log',
    header: '[SYSTEM NOTICE — EVENT EXECUTION IMMINENT]',
    teaser: 'Jan 25 · Theater 9 · 5:00 PM',
    byline: null,
    body: (
      <>
        Wake from sleep. The date is approaching.
        <br /><br />
        NEUTRALS will be unleashed on{' '}
        <a
          href="data:text/calendar;charset=utf-8,BEGIN:VCALENDAR%0AVERSION:2.0%0APRODID:-//The Two Jakes//NEUTRALS//EN%0ABEGIN:VEVENT%0AUID:neutrals-screening-20250125@2jakes.tv%0ADTSTAMP:20250117T000000Z%0ADTSTART:20250125T220000Z%0ADTEND:20250126T000000Z%0ASUMMARY:NEUTRALS Celebration Screening%0ADESCRIPTION:Theater 9%5Cn%5CnCheck-in: 4:00 PM%2C outside the auditorium entrance%5Cn%5CnAttendees are advised to arrive in their NEUTRALS best%E2%80%94whether that manifests as formal wear or a trusted Leon Kennedy bomber jacket. A photographer will be present to record this unparalleled event.%5Cn%5CnOfficial commemorative materials will be available on-site%2C including mini posters of artwork by Steven Weed (Wes)%2C and NEUTRALS shirts and reflective stickers featuring the updated title card design by Jake O'Brien.%5Cn%5CnThis event will not be repeated. Attendance is strongly recommended.%0ALOCATION:100 E Maple Rd, Troy, MI 48083%0ASTATUS:CONFIRMED%0AEND:VEVENT%0AEND:VCALENDAR"
          download="NEUTRALS_Screening.ics"
        >
          January 25 at 5:00 PM at the MJR Troy Cinema
        </a>.
        <br /><br />
        <a href="https://maps.app.goo.gl/oseyn6nRhG5XYdfv6" target="_blank" rel="noopener noreferrer">
          100 E Maple Rd<br />
          Troy, MI&nbsp;&nbsp;48083<br />
          United States
        </a>
        <br /><br />
        <strong>Location</strong>: Theater 9
        <br /><br />
        <strong>Check-in</strong>: 4:00 PM, outside the auditorium entrance
        <br /><br />
        Attendees are advised to arrive in their NEUTRALS best&mdash;whether that manifests as formal wear or a trusted Leon Kennedy bomber jacket. A photographer will be present to record this unparalleled event.
        <br /><br />
        Official commemorative materials will be available on-site, including mini posters of artwork by Steven Weed (Wes), and NEUTRALS shirts and reflective stickers featuring the updated title card design by Jake O'Brien.
        <br /><br />
        This event will not be repeated. Attendance is strongly recommended.
        <br /><br />
        <a href={celebrationFlyer} download>
          <img className="poster" alt="NEUTRALS Celebration Screening - January 25th Event Flyer" src={celebrationFlyerCompressed} loading="lazy" />
        </a>
        <br />
        <strong>Status</strong>: Confirmed.
      </>
    ),
    log: [],
  },
  {
    slug: 'holiday_update.log',
    header: '[HOLIDAY TRANSMISSION - NEUTRALS] [12/25/2025]',
    teaser: 'A holiday gift: the screening date',
    byline: null,
    body: (
      <>
        This holiday season at The Two Jakes, we're issuing a gift: a Neutrals celebration screening.
        <br /><br />
        After an extended period of anticipation, we're prepared to announce that a celebratory screening will take place on Sunday, January 25th, at the MJR Troy cinema.
        <br /><br />
        Keep your comms open for status updates regarding ticket access and further details.
        <br /><br />
        Merry Christmas from The Two Jakes!
        <br /><br />
        <img className="poster" alt="The Two Jakes Neutrals - January 25th Celebration Screening" src={christmasAnnouncementCompressed} loading="lazy" />
      </>
    ),
    log: [
      { cmd: 'verify("event_status")', out: 'Event status: confirmed' },
      { cmd: 'unlock("calendar")', out: 'Calendar: unlocked' },
    ],
  },
  {
    slug: 'system_update_1.1.log',
    header: '[SYSTEM UPDATE 1.1 - NEUTRALS] [11/10/2025]',
    teaser: 'New teaser poster + wallpapers',
    byline: null,
    body: (
      <>
        We wish to thank you for your support and understanding.
        Your patience continues to fuel the operation.
        <br /><br />
        Our team remains locked in, carefully mastering every frame, every tone, every imperceptible vibration until it achieves total balance.
        <br /><br />
        Internal projections suggest completion before year&rsquo;s end, provided we remain undisturbed.
        This is a delicate process&mdash;akin to landing your first 1,000,000+ point combo in Pro Skater during an earthquake.
        <br /><br />
        While you wait, please relish this <a href={poster} download>new teaser poster</a>, designed by our very own Steven Weed&mdash;who also portrays Wes in NEUTRALS.
        We've also prepared <a href={wallpapersZip} download>mobile wallpaper variations</a> for your personal devices.
        <br />
        <a href={poster} download>
          <img className="poster" alt="The Two Jakes film productions presents: Neutrals" src={posterCompressed} loading="lazy" />
        </a>
      </>
    ),
    log: [
      { cmd: 'standby()', out: null },
      { cmd: 'process("final_master")', out: 'status: active' },
    ],
  },
  {
    slug: 'system_launch.log',
    header: '[SYSTEM LAUNCH - NEUTRALS] [7/1/2025]',
    teaser: 'Welcome to 2Jakes.tv',
    byline: null,
    body: (
      <>
        Welcome Soldiers of Cinema to{' '}
        <a href="https://2jakes.tv/">2Jakes.tv</a> and{' '}
        <a href="https://neutralsfilm.com/">neutralsfilm.com</a>!
        <br /><br />
        Your central hub for the latest updates on the punk rock comedy film{' '}
        <em>Neutrals</em> and future creative projects from The Two Jakes Film
        Productions (est. 2022).
        <br /><br />
        Click the <strong>NEWS</strong> banner to reopen this window and
        stay up-to-date on where you can find <em>Neutrals</em> next!
        <br /><br />
        <CreditsBlock />
      </>
    ),
    log: [],
  },
];

const DISPATCH_BY_SLUG = Object.fromEntries(DISPATCHES.map(d => [d.slug, d]));

// A tiny fake filesystem, just deep enough to make `ls`/`cat`/`cd` feel
// real: home, the dispatches directory, and two standalone files the
// command shell can surface without digging through the sidebar.
const FS = {
  '~': { type: 'dir', children: ['dispatches', 'credits', 'wallpapers'] },
  '~/dispatches': { type: 'dir', children: DISPATCHES.map(d => d.slug) },
  '~/credits': { type: 'file' },
  '~/wallpapers': { type: 'file' },
};
DISPATCHES.forEach(d => { FS[`~/dispatches/${d.slug}`] = { type: 'file' }; });

// Resolves a typed path (bare name, `../`, `~/absolute`, or empty) against
// the current directory into a normalized `~/a/b` form. Doesn't touch FS
// itself — callers look the result up there.
const resolvePath = (cwd, input) => {
  // No argument: stay put. (Callers that want "no argument means home" —
  // real `cd`'s actual behavior — special-case that themselves; `ls` with
  // no argument correctly means "list here", not "list home".)
  if (!input) return cwd;
  const absolute = input.startsWith('~');
  const rest = (absolute ? input.slice(1) : input).replace(/^\/+/, '');
  const baseParts = (absolute || cwd === '~') ? [] : cwd.replace(/^~\/?/, '').split('/').filter(Boolean);
  const stack = [...baseParts];
  rest.split('/').forEach(part => {
    if (!part || part === '.') return;
    if (part === '..') stack.pop();
    else stack.push(part);
  });
  return stack.length ? `~/${stack.join('/')}` : '~';
};

const HELP_LINES = [
  'ls [dir]        list files',
  'cat <file>      read a file',
  'cd [dir]        change directory',
  'pwd             print working directory',
  'whoami          who you are',
  'clear           clear the screen',
  'exit / quit     close this window',
  'help            this list',
];

const NEOFETCH_LINES = [
  'OS: NeutralsOS 26.09 (Troy)',
  'Host: The Two Jakes Film Productions',
  'Kernel: soldier_of_cinema',
  'Shell: dispatches-sh',
  'Terminal: View Master MK III',
  'Uptime: since 2022',
  'CPU: caffeine (99% idle, 1% panic)',
  'Memory: 1 idea / infinite deadlines',
];

// Define the boot sequence lines (unchanged from the original single-scroll
// feed) — the typewriter greeting still plays once per visit before the
// real two-pane shell takes over.
const makeBootLines = lastLogin => [
  { text: 'login soldier_of_cinema', type: 'typed', speed: 60 },
  { text: '********', type: 'typed', speed: 20, delay: 200 },
  { text: `Last login: ${lastLogin} on ttys000`, type: 'instant', delay: 150 },
];

export default function NewsTerminal({ onRequestClose }) {
  // ---- boot typewriter (unchanged mechanic, trimmed to the login beat) ----
  const [bootLines, setBootLines] = useState([]);
  const [bootBuffer, setBootBuffer] = useState('');
  const [booted, setBooted] = useState(false);
  const lineRef = useRef(0);
  const charRef = useRef(0);
  const bootTimeoutRef = useRef(null);

  const lastLogin = useRef(
    new Date(parseInt(localStorage.getItem('lastVisit') || Date.now(), 10)).toLocaleString()
  );
  useEffect(() => {
    localStorage.setItem('lastVisit', Date.now().toString());
  }, []);

  useEffect(() => {
    const script = makeBootLines(lastLogin.current);
    function nextStep() {
      if (lineRef.current >= script.length) {
        bootTimeoutRef.current = setTimeout(() => setBooted(true), 400);
        return;
      }
      const { text, type, speed = 0, delay = 0 } = script[lineRef.current];
      bootTimeoutRef.current = setTimeout(() => {
        if (type === 'instant') {
          setBootLines(l => [...l, text]);
          lineRef.current++;
          nextStep();
        } else {
          charRef.current = 0;
          typeChar();
        }
      }, delay);

      function typeChar() {
        if (charRef.current < text.length) {
          setBootBuffer(text.slice(0, ++charRef.current));
          bootTimeoutRef.current = setTimeout(typeChar, speed + Math.random() * 50);
        } else {
          setBootLines(l => [...l, text]);
          setBootBuffer('');
          lineRef.current++;
          bootTimeoutRef.current = setTimeout(nextStep, 100);
        }
      }
    }
    nextStep();
    return () => clearTimeout(bootTimeoutRef.current);
  }, []);

  // ---- the command shell, once booted ----
  const [cwd, setCwd] = useState('~');
  // 'file' shows a dispatch/credits/wallpapers; 'output' shows a command's
  // printed result; 'idle' is the blank state `clear` leaves behind.
  const [viewMode, setViewMode] = useState('file');
  const [openFile, setOpenFile] = useState(DISPATCHES[0].slug);
  const [output, setOutput] = useState(null); // { command, lines }
  const [inputValue, setInputValue] = useState('');
  const [history, setHistory] = useState([]);
  const [historyIndex, setHistoryIndex] = useState(null);
  const inputRef = useRef(null);

  const openDispatch = useCallback(slug => {
    setViewMode('file');
    setOpenFile(slug);
  }, []);

  const showOutput = useCallback((command, lines) => {
    setViewMode('output');
    setOutput({ command, lines });
  }, []);

  const runCommand = useCallback(raw => {
    const trimmed = raw.trim();
    if (!trimmed) return;
    const lower = trimmed.toLowerCase();
    const [cmd, ...args] = trimmed.split(/\s+/);
    const cmdLower = cmd.toLowerCase();
    const arg = args.join(' ');

    // Exact-phrase jokes, checked before the single-word switch below.
    if (lower === 'sudo rm -rf /' || lower === 'rm -rf /') {
      return showOutput(trimmed, ["Absolutely not. We already lost a hard drive on this production once. Once."]);
    }
    if (lower === 'git blame') {
      return showOutput(trimmed, ['3f2a891 (Justin Morrow  2026-09-08) // this whole file, unfortunately']);
    }
    if (lower === 'format c:') {
      return showOutput(trimmed, ["This isn't Windows 95. Even if it were — no."]);
    }

    switch (cmdLower) {
      case 'ls': {
        const target = resolvePath(cwd, arg);
        const entry = FS[target];
        if (!entry) return showOutput(trimmed, [`ls: no such file or directory: ${arg || target}`]);
        if (entry.type === 'file') return showOutput(trimmed, [target.split('/').pop()]);
        return showOutput(trimmed, entry.children.map(name => FS[`${target}/${name}`]?.type === 'dir' ? `${name}/` : name));
      }
      case 'cat': {
        if (!arg) return showOutput(trimmed, ['usage: cat <file>']);
        const target = resolvePath(cwd, arg);
        const entry = FS[target];
        if (!entry) return showOutput(trimmed, [`cat: no such file or directory: ${arg}`]);
        if (entry.type === 'dir') return showOutput(trimmed, [`cat: ${arg}: Is a directory`]);
        if (target === '~/credits') { openDispatch('credits'); return; }
        if (target === '~/wallpapers') { openDispatch('wallpapers'); return; }
        const slug = target.split('/').pop();
        if (DISPATCH_BY_SLUG[slug]) { openDispatch(slug); return; }
        return showOutput(trimmed, [`cat: no such file or directory: ${arg}`]);
      }
      case 'cd': {
        // Bare `cd` means "go home" (real shell behavior) — resolvePath's
        // own no-argument default is "stay put", which is what `ls` wants
        // but not what `cd` wants, so it's overridden here.
        const target = arg ? resolvePath(cwd, arg) : '~';
        const entry = FS[target];
        if (!entry) return showOutput(trimmed, [`cd: no such directory: ${arg}`]);
        if (entry.type !== 'dir') return showOutput(trimmed, [`cd: not a directory: ${arg}`]);
        setCwd(target);
        return;
      }
      case 'pwd':
        return showOutput(trimmed, [cwd]);
      case 'whoami':
        return showOutput(trimmed, ['soldier_of_cinema']);
      case 'help':
        return showOutput(trimmed, HELP_LINES);
      case 'clear':
        setViewMode('idle');
        setOutput(null);
        return;
      case 'exit':
      case 'quit':
        if (typeof onRequestClose === 'function') onRequestClose();
        else showOutput(trimmed, ["Can't close from here — use the button up top."]);
        return;
      case 'neofetch':
      case 'fastfetch':
        return showOutput(trimmed, NEOFETCH_LINES);
      case 'sudo':
        return showOutput(trimmed, ["Nice try. Nobody on this crew has that kind of authority — not even craft services."]);
      case 'passwd':
        return showOutput(trimmed, ["Nice try. It's already ********."]);
      case 'vim':
      case 'vi':
      case 'emacs':
        return showOutput(trimmed, ['Read-only, sorry.']);
      case 'docker':
        return showOutput(trimmed, ["We don't do containers. We do practical effects."]);
      case 'kubectl':
        return showOutput(trimmed, ["This isn't that kind of production."]);
      case 'curl':
      case 'wget':
        return showOutput(trimmed, ['This machine doesn’t leave the building. Neither does the developer, most days.']);
      case 'claude':
      case 'chatgpt':
      case 'gemini':
      case 'copilot':
        return showOutput(trimmed, ["Come on. You think we're made of money?"]);
      default:
        return showOutput(trimmed, [`${cmd}: command not found (try 'help')`]);
    }
  }, [cwd, onRequestClose, openDispatch, showOutput]);

  const handleSubmit = e => {
    e.preventDefault();
    const raw = inputValue;
    if (!raw.trim()) return;
    runCommand(raw);
    setHistory(h => [...h, raw]);
    setHistoryIndex(null);
    setInputValue('');
  };

  const handleKeyDown = e => {
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (history.length === 0) return;
      const next = historyIndex === null ? history.length - 1 : Math.max(0, historyIndex - 1);
      setHistoryIndex(next);
      setInputValue(history[next]);
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (historyIndex === null) return;
      const next = historyIndex + 1;
      if (next >= history.length) {
        setHistoryIndex(null);
        setInputValue('');
      } else {
        setHistoryIndex(next);
        setInputValue(history[next]);
      }
    }
  };

  const prompt = cwd === '~' ? '$' : `${cwd} $`;

  if (!booted) {
    return (
      <div className="nt-boot">
        {bootLines.map((ln, i) => <div key={i} className="nt-boot-line">{ln}</div>)}
        {bootBuffer && (
          <div className="nt-boot-line">
            <span className="nt-boot-prompt">$</span> {bootBuffer}<span className="nt-cursor" />
          </div>
        )}
      </div>
    );
  }

  const renderFile = () => {
    if (openFile === 'credits') {
      return (
        <>
          <div className="nt-breadcrumb">$ cat credits</div>
          <div className="nt-header">[CREDITS]</div>
          <div className="nt-text"><CreditsBlock /></div>
        </>
      );
    }
    if (openFile === 'wallpapers') {
      return (
        <>
          <div className="nt-breadcrumb">$ cat wallpapers</div>
          <div className="nt-header">[WALLPAPERS]</div>
          <div className="nt-text">
            Mobile wallpaper variations, based on the official teaser poster.
            <br /><br />
            <a href={wallpapersZip} download>Download wallpapers (.zip)</a>
          </div>
        </>
      );
    }
    const d = DISPATCH_BY_SLUG[openFile];
    if (!d) return null;
    return (
      <>
        <div className="nt-breadcrumb">$ cat dispatches/{d.slug}</div>
        <div className="nt-header">{d.header}</div>
        {d.byline && <div className="nt-byline">{d.byline}</div>}
        <div className="nt-text">{d.body}</div>
        {d.log.length > 0 && (
          <div className="nt-log">
            {d.log.map((entry, i) => (
              <React.Fragment key={i}>
                <div><span className="nt-amber">$</span> {entry.cmd}</div>
                {entry.out && <div>&#9492;&#9472; {entry.out}</div>}
              </React.Fragment>
            ))}
          </div>
        )}
        <div className="nt-end">END TRANSMISSION</div>
      </>
    );
  };

  return (
    <div className="news-terminal-shell">
      <div className="nt-strip">Last login: {lastLogin.current} on ttys000</div>

      <div className="nt-body">
        <div className="nt-sidebar">
          <div className="nt-sidebar-header">$ ls dispatches/ <span className="nt-dim">({DISPATCHES.length})</span></div>
          <div className="nt-file-list">
            {DISPATCHES.map(d => (
              <button
                key={d.slug}
                type="button"
                className={`nt-file${viewMode === 'file' && openFile === d.slug ? ' nt-file-active' : ''}`}
                onClick={() => openDispatch(d.slug)}
              >
                <div className="nt-file-name">
                  <span>{viewMode === 'file' && openFile === d.slug ? '❯' : '  '}</span> {d.slug}
                </div>
                <div className="nt-file-teaser">{d.teaser}</div>
              </button>
            ))}
          </div>
        </div>

        <div className="nt-detail">
          {viewMode === 'file' && renderFile()}
          {viewMode === 'output' && output && (
            <>
              <div className="nt-breadcrumb">$ {output.command}</div>
              <div className="nt-text">
                {output.lines.map((ln, i) => <div key={i}>{ln}</div>)}
              </div>
            </>
          )}
        </div>
      </div>

      <form className="nt-cmdbar" onSubmit={handleSubmit}>
        <span className="nt-amber">{prompt}</span>
        <input
          ref={inputRef}
          className="nt-input"
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="try ls, or help"
          autoComplete="off"
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck="false"
          aria-label="Command input"
        />
      </form>
    </div>
  );
}
